import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { NAV_RESET_EVENT_GROUPS } from './Header';
import UpcomingEventGroups from './UpcomingEventGroups';
import './Events.css';

const Events = () => {
  const location = useLocation();
  const [selectedEvent, setSelectedEvent] = useState(null);
  const [registrationGroupOpen, setRegistrationGroupOpen] = useState(false);

  useEffect(() => {
    if (location.state?.[NAV_RESET_EVENT_GROUPS] == null) return;
    setSelectedEvent(null);
  }, [location.state]);

  const pastEvents = [
    {
      id: 7,
      title: 'Dallas TX Swim Lessons – June & July 2026',
      date: 'Jun. 1, Jun. 16, Jun. 22, Jun. 29, Jul. 13 & Jul. 14, 2026',
      location: 'Fretz Aquatic Center (14778 Hillcrest Rd, Dallas, TX 75254)',
      description:
        'In collaboration with Dallas Parks and Recreation, Swim With a Splash offered private swim lessons led by competitive swimmers from top swimming clubs.'
    },
    {
      id: 6,
      title: 'Southlake Texas Swim Lessons – September 1, 2025',
      date: 'September 1, 2025',
      location: 'Southlake, Texas',
      description: 'Free private swim lessons offered by Lakeside Aquatic Club and North Texas Natadores swimmers.',
      image: '/event-photos/southlake_coach_Picture3.jpg',
      video: '/event-photos/Southlake_2025.mp4',
      teamPhoto: 'southlake_coach_Picture3.jpg',
      teamDescription: 'September 1, 2025\nFrom left to right: Valentina Calderon, Rebecca Yao, Austin Yao, Aiden Ji, Lucas Sun',
      /*
      additionalPhotos: [
        {
          image: '/event-photos/southlake_coach_Picture2.jpg',
          date: 'August 24, 2025',
          description: 'From left to right: Valentina Calderon, Austin Yao, Aiden Ji, Lucas Sun'
        }
      ]*/
    },
    {
      id: 4,
      title: 'Southlake Texas Swim Lessons – August 23 & 24, 2025',
      date: 'August 23 & 24, 2025',
      location: 'Southlake, Texas',
      description: 'Free private swim lessons offered by Lakeside Aquatic Club and North Texas Natadores swimmers.',
      image: '/event-photos/southlake_coach_Picture1.jpg',
      teamPhoto: 'southlake_coach_Picture1.jpg',
      teamDescription: 'August 23, 2025\nFrom left to right: Lucas Sun, Rebecca Yao, Olivia Ye, Austin Yao, (Aiden Ji)',
      additionalPhotos: [
        {
          image: '/event-photos/southlake_coach_Picture2.jpg',
          date: 'August 24, 2025',
          description: 'From left to right: Valentina Calderon, Austin Yao, Aiden Ji, Lucas Sun'
        }
      ]
    },
    {
      id: 5,
      title: 'California Swim Lessons – August 9 & 10, 2025',
      date: 'August 9 & 10, 2025',
      location: 'California',
      description: 'Free private swim lessons offered by Pacific Swim swimmers.',
      image: '/event-photos/CA_Coaches.jpg',
      teamPhoto: 'CA_Coaches.jpg',
      teamDescription: 'From left to right: Katie An，Connor Ho， Yimo Liu，Ryker Liu'
    },
    {
      id: 3,
      title: 'Mason Ohio Swim Lessons – May 24 & 25, 2025',
      date: 'May 24 & 25, 2025',
      location: 'Mason Community Center',
      description: 'Free private swim lessons offered by Mason Manta Rays swimmers.',
      image: '/event-photos/year3mason.jpeg',
      teamPhoto: 'year3mason.jpeg',
      teamDescription: 'From left to right: Sharon Li, Anna Yu, Claire Liu, Caleb Tan, Victor Cao, Andrew Zhang'
    },
    {
      id: 2,
      title: 'Chestnut Hill Mason Ohio Swim Lessons – May 18 & 19, 2024',
      date: 'May 18 & 19, 2024',
      location: 'Chestnut Hill Community Pool',
      description: 'Free private swim lessons offered by Mason Manta Rays swimmers.',
      image: '/event-photos/year2groupphoto.jpg',
      video: '/event-photos/year2.mp4',
      teamPhoto: 'year2groupphoto.jpg',
      teamDescription: 'Front row: Rebecca Yao, George Cao, Andrew Zhang\nSecond row: Sharon Li, Victor Cao, Caleb Tan, Austin Yao'
    },
    {
      id: 1,
      title: 'Chestnut Hill Mason Ohio Swim Lessons – August 14, 15 & 16, 2023',
      date: 'August 14, 15 & 16, 2023',
      location: 'Chestnut Hill Community Pool',
      description: 'Free private swim lessons offered by Mason Manta Rays swimmers.',
      image: '/event-photos/year1groupphoto.jpg',
      video: '/event-photos/year1.mp4',
      teamPhoto: 'year1groupphoto.jpg',
      teamDescription: 'Front row: Victor Cao, Rebecca Yao, and George Cao\nSecond row: Sharon Li, Bryan Zhang, Austin Yao'
    }
  ];

  const handleEventClick = (event) => {
    setSelectedEvent(event);
  };

  const handleBackToEvents = () => {
    setSelectedEvent(null);
  };

  if (selectedEvent) {
    return (
      <div className="event-detail">
        <header className="event-header">
          <div className="event-header-content">
            <img src="/logo.png" alt="Swim With a Splash Logo" className="event-logo" />
            <h1>Swim With a Splash</h1>
          </div>
          <nav className="event-nav">
            <button onClick={handleBackToEvents}>Back to Events</button>
          </nav>
        </header>
        
        <div className="container">
          <section className="section">
            <h2>{selectedEvent.title}</h2>
            
            <div className="card">
              <h3>Event Details</h3>
              <p><strong>Date:</strong> {selectedEvent.date}</p>
              <p><strong>Location:</strong> {selectedEvent.location}</p>
              <p><strong>Description:</strong> {selectedEvent.description}</p>
            </div>
            
            {selectedEvent.image && selectedEvent.teamDescription ? (
            <div className="card">
              <h3>Coach Team</h3>
              <img 
                src={selectedEvent.image} 
                alt={selectedEvent.title} 
                className="event-team-photo"
              />
              <p className="team-description">
                {selectedEvent.teamDescription.split('\n').map((line, index) => (
                  <span key={index}>
                    {line}
                    {index < selectedEvent.teamDescription.split('\n').length - 1 && <br />}
                  </span>
                ))}
              </p>
              
              {selectedEvent.additionalPhotos && selectedEvent.additionalPhotos.map((photo, index) => (
                <div key={index} className="additional-photo">
                  <img 
                    src={photo.image} 
                    alt={`${selectedEvent.title} - ${photo.date}`} 
                    className="event-team-photo"
                  />
                  <p className="team-description">
                    <strong>{photo.date}</strong><br />
                    {photo.description}
                  </p>
                </div>
              ))}
            </div>
            ) : null}
            
            {selectedEvent.video && (
              <div className="card">
                <h3>Event Video</h3>
                <video width="100%" controls className="event-video">
                  <source src={selectedEvent.video} type="video/mp4" />
                  Your browser does not support the video tag.
                </video>
              </div>
            )}
          </section>
        </div>
        
        <button onClick={handleBackToEvents} className="back-btn">Back to Events</button>
      </div>
    );
  }

  return (
    <div className="events">
      <div className="container">
        <section className="section">
          <h2>Events</h2>
          
          <div className="card">
            <h3>Upcoming Events</h3>
            <UpcomingEventGroups
              variant="events"
              pastEvents={pastEvents}
              onPastEventClick={handleEventClick}
              onSelectionChange={(groupId) => setRegistrationGroupOpen(Boolean(groupId))}
            />
          </div>

          {!registrationGroupOpen ? (
            <div className="card">
              <h3>Past Events</h3>
              {pastEvents.map(event => (
                <div key={event.id} className="card">
                  <h3>{event.title}</h3>
                  <button
                    onClick={() => handleEventClick(event)}
                    className="past-event-learn-more-btn"
                  >
                    Learn More
                  </button>
                </div>
              ))}
            </div>
          ) : null}
        </section>
      </div>
    </div>
  );
};

export default Events;
